import { render, staticRenderFns } from "./ModalAtualizacao.vue?vue&type=template&id=765d4a5e&"
import script from "./ModalAtualizacao.vue?vue&type=script&lang=js&"
export * from "./ModalAtualizacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtualizacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports